<template>
	<div>
		<div class="tables" style="padding-bottom: 50px;position: relative; width: 100%;min-height: 700px; background-color: white;padding: 0 1.25rem;padding-top: 0.9375rem;position: relative;">
			
			<div style="display: flex;">
				
				<div  style="display: flex;align-items: baseline;margin-left: 30px;width: 100%;">
					<p style="margin-right: 0.9375rem;">月度</p>
					<a-month-picker style="width: 120px;" v-model="selectedMonth" :disabled-date="disabledDate" placeholder="请选择日期" />
					<div style="flex: 1;"></div>
					<div style="">
						<a-button @click="resetTables" style="width: 4.25rem;height: 2.25rem;margin: 0 1.5625rem;">
							重置
						</a-button>
						<a-button @click="searchTables" style="width: 4.25rem;height: 2.25rem;" type="primary">
							搜索
						</a-button>
					</div>
				</div>
			</div>
			
			
			<div style="width: 100%;border-bottom: 1px solid gainsboro;margin-bottom: 25px;margin-top: 20px;">
				
			</div>
			<div v-if="monthData.length==0" style="width: 100%;min-height: 250px; margin: 0 auto;background-color: white;">
				<a-result  title="暂无数据">
				   
				  </a-result>
			</div>
			<a-row style="display: flex;flex-wrap: wrap;">
				<a-col :span="10" v-for="(item,index) in monthData" style="margin-left: 85px;margin-bottom: 20px;">
					<div style="width: 100%;height: 192px;border: 1.5px solid #DFDFDF;">
						<div style="width: 100%;height: 2.125rem;border-bottom: 1.7px  solid #DFDFDF;display: flex;justify-content: space-between;padding: 0 15px;padding-top: 5px;">
							<p style="font-weight: 500;">{{item.statisticsMonth}}</p>
							<p  style="font-weight: 500;">{{item.realName}}/{{item.cellphone}}</p>
						</div>
						<div style="display: flex;flex-wrap: wrap;width: 96%;justify-content: space-around;margin: 0 auto;">
							<div style="width: 30%;height: 3.45rem;background-color: #F8F8F8;margin: 10px 0;padding-left: 8px;">
								<p style="font-size: 16px;color: #4183BC;font-weight: 500;margin: 0;">总消费</p>
								<p style="font-size: 16px;color: #0072FF;font-weight: 500;margin: 0;">￥<span style="font-size: 20px;">{{item.totalCost}}</span></p>
							</div>
							<div style="width: 30%;height: 3.45rem;background-color: #F8F8F8;margin: 10px 0;padding-left: 8px;">
								<p style="font-size: 16px;color: #4183BC;font-weight: 500;margin: 0;">累计预约</p>
								<p style="font-size: 16px;color: #0072FF;font-weight: 500;margin: 0;"><span style="font-size: 20px;">{{item.bookHours}} </span>小时、<span style="font-size: 20px;">{{item.bookCount}} </span>次</p>
							</div>
							<div style="width: 30%;height: 3.45rem;background-color: #F8F8F8;margin: 10px 0;padding-left: 8px;">
								<p style="font-size: 16px;color: #4183BC;font-weight: 500;margin: 0;">累计运行</p>
								<p style="font-size: 16px;color: #0072FF;font-weight: 500;margin: 0;"><span style="font-size: 20px;">{{item.runHours}} </span>小时、<span style="font-size: 20px;">{{item.runCount}} </span>次</p>
							</div>
							<div style="width: 30%;height: 3.45rem;background-color: #F8F8F8;margin: 10px 0;padding-left: 8px;">
								<p style="font-size: 16px;color: #4183BC;font-weight: 500;margin: 0;">爽约</p>
								<p style="font-size: 16px;color: #0072FF;font-weight: 500;margin: 0;"><span style="font-size: 20px;color: #DB2A50;">{{item.bookNotUseCount}} </span>次</p>
							</div>
							<div style="width: 30%;height: 3.45rem;background-color: #F8F8F8;margin: 10px 0;padding-left: 8px;">
								<p style="font-size: 16px;color: #4183BC;font-weight: 500;margin: 0;">取消</p>
								<p style="font-size: 16px;color: #0072FF;font-weight: 500;margin: 0;"><span style="font-size: 20px;color: #24244F;">{{item.bookCancelCount}} </span>次</p>
							</div>
							<div style="width: 30%;height: 3.45rem;background-color: #F8F8F8;margin: 10px 0;padding-left: 8px;">
								<p style="font-size: 16px;color: #4183BC;font-weight: 500;margin: 0;">审核失败</p>
								<p style="font-size: 16px;color: #0072FF;font-weight: 500;margin: 0;"><span style="font-size: 20px;color: #FF0B09;">{{item.bookFailCount}} </span>次</p>
							</div>
						</div>
					</div>
				</a-col>
				<!-- <a-col :span="11">
					<div style="width: 100%;height: 192px;border: 1px solid #DFDFDF;">
						
					</div>
				</a-col> -->
			</a-row>
			<div style="padding: 30px 0;display: flex;justify-content: center;align-items: center;margin-left: -350px;">
				<a-pagination :defaultPageSize="6" :pageSizeOptions="['6', '12', '36', '240']" v-model="queryPage.current"
					@showSizeChange="changeSize" @change="changeCurrent"
					style="display: block !important;margin-left: 15.625rem" size="small" :total="total" show-size-changer
					show-quick-jumper />
			</div>
			
		</div>
		<!-- <div style="position: absolute;bottom: -2.5rem;left: 23rem" v-show="!disabledPage">
			
		</div> -->
	</div>
</template>

<script>
	import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
	import moment from 'moment'
	import {SelMonthlySummary} from '@/api/index.js'
	export default {
		name:'/core/monthlySum',
		data() {
			return {
			selectedMonth:'',
			monthData:[],
			queryPage: {
				current: 1,
				pageSize: 6
			},
			total:0,
			}
		},
		created() {
			SelMonthlySummary({Month:'',page:1,row:200000}).then((res)=>{
				this.total = res.data.totalCount
			})
			if(this.selectedMonth==null){
				this.selectedMonth=''
			}
			this.getSelMonthlySummary({Month:this.selectedMonth==''?'':moment(this.selectedMonth).format('YYYY-MM'),page:this.queryPage.current,row:this.queryPage.pageSize})
		},
		methods:{
			async getSelMonthlySummary(data){
				const res = await SelMonthlySummary(data)
				this.monthData = res.data.data
				
				 console.log(res)
			},
			changeSize(current,size){
				this.queryPage.pageSize = size
				this.queryPage.current = current
				if(this.selectedMonth==null){
					this.selectedMonth=''
				}
				this.getSelMonthlySummary({Month:this.selectedMonth==''?'':moment(this.selectedMonth).format('YYYY-MM'),page:this.queryPage.current,row:this.queryPage.pageSize})
			},
			changeCurrent(val){
				this.queryPage.current = val
				if(this.selectedMonth==null){
					this.selectedMonth=''
				}
				this.getSelMonthlySummary({Month:this.selectedMonth==''?'':moment(this.selectedMonth).format('YYYY-MM'),page:this.queryPage.current,row:this.queryPage.pageSize})
			},
			resetTables(){
				this.selectedMonth=''
				if(this.selectedMonth==null){
					this.selectedMonth=''
				}
				this.getSelMonthlySummary({Month:this.selectedMonth==''?'':moment(this.selectedMonth).format('YYYY-MM'),page:this.queryPage.current,row:this.queryPage.pageSize})
			},
			searchTables(){
				console.log(this.selectedMonth)
				if(this.selectedMonth==null){
					this.selectedMonth=''
				}
				this.getSelMonthlySummary({Month:this.selectedMonth==''?'':moment(this.selectedMonth).format('YYYY-MM'),page:this.queryPage.current,row:this.queryPage.pageSize})
			},
		}
	};
</script>

<style>
</style>
